import {
    HttpGetDemandForecast
} from "@/service/purchase/purchase.js";
export default {
    data () {
        return {
            demandClassList: []
        }
    },
    created () {
        this.getDemandClass();
    },
    methods: {
        getDemandClass () {
            HttpGetDemandForecast().then(res => {
                this.demandClassList = res.data.map(item => {
                    return {
                        label: item.name,
                        value: item.id,
                        attach: {
                            ...item
                        }
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        }
    }
}